import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { haLaVoce } from '../../utils/permessi';
import { ascoltaNonLetti } from '../../services/messaggiApi';
import './Busta.css';

/**
 * LA BUSTA DEI MESSAGGI, accanto al saldo: su computer e su telefono, nella
 * testata di serie (BarraAlta) e in quella di Nova (TestataNova).
 *
 * Il numero rosso sono i messaggi non letti (services/messaggiApi.js, lo
 * stesso conto che apre la finestra degli importanti); senza non letti
 * resta la busta, senza numero. Toccata, porta a Il mio conto ›
 * Messaggistica. Chi non ha SITE_MESSAGES_VIEW non la vede.
 */
export default function Busta({ dentro, classe = '' }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const puo = dentro && haLaVoce('SITE_MESSAGES_VIEW');
  const [quanti, setQuanti] = useState(0);

  useEffect(() => {
    if (!puo) return undefined;
    return ascoltaNonLetti((stato) => setQuanti((stato && stato.nonLetti) || 0));
  }, [puo]);

  if (!puo) return null;

  const etichetta = quanti > 0 ? t('Messaggi, {{n}} da leggere', { n: quanti }) : t('Messaggi');
  return (
    <button type="button" className={('busta-messaggi ' + classe).trim()} aria-label={etichetta} title={etichetta}
            onClick={() => navigate('/my-account/messaggi')}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"
           strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="2.5" />
        <path d="M4 7l8 6 8-6" />
      </svg>
      {quanti > 0 && <span className="busta-numero" aria-hidden="true">{quanti > 99 ? '99+' : quanti}</span>}
    </button>
  );
}
